import React from 'react';
import {H2} from '../../../components/crousal/Headings';
import {Button, ButtonType, ButtonSize} from '../../../components/crousal/Button';


interface IProps {
    onChange: (step: number) => void;
}

export function Step4({onChange}: IProps) {

    function finalStep() {
        onChange(1);
    }

    return (
        <div>
            <H2 className="mt-6 lg:mt-10">Step 4 - Terms of Sale</H2>
            <div
                className="items-center lg:mt-6 text-30 justify-center lg:w-2/5 text-sm lg:mx-auto text-center">
                By selling your account through our website you confirm that you are current, and the only user of the
                account and agree to our
                <span className="text-smurfs-gold cursor-pointer"> Terms of Service</span>.
            </div>
            <div
                className="items-center lg:mt-2 text-30 justify-center lg:w-2/5 text-sm lg:mx-auto text-center">
                Payouts for accounts are sent to your bank account or credit card
                <span className="text-smurfs-gold cursor-pointer"> View country eligibility for payouts</span>.
            </div>
            <div className="mt-6 mb-10 text-md">
                <Button type={ButtonType.DEFAULT} size={ButtonSize.DEFAULT} onClick={finalStep}>
                    Next
                </Button>
            </div>
        </div>
    );
}
